var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Projects grid"},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"grid-auto-md"},_vm._l((_vm.page.projects),function(project){return _c('AboutThumb',{key:project.url,attrs:{"item":project}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }